import { helpers } from 'vuelidate/lib/validators';

export default (...passwordRequirements) => value => {
  if (!helpers.req(value)) {
    return true;
  }

  if (!passwordRequirements || !passwordRequirements.length) {
    passwordRequirements = [passwordRequirementsTypes.oneDigit, passwordRequirementsTypes.oneBigLetter];
  }

  for (let requirement of passwordRequirements) {
    if (requirement & passwordRequirementsTypes.oneDigit) {
      if (!/(?=.*[0-9])/.test(value)) {
        return false;
      }
    } else if (requirement & passwordRequirementsTypes.oneBigLetter) {
      if (!/(?=.*[\p{Lu}])/u.test(value)) {
        return false;
      }
    }
  }

  return true;
};

const passwordRequirementsTypes = {
  oneDigit: 0b01,
  oneBigLetter: 0b10
};

export { passwordRequirementsTypes };
